import * as factories from './factories';

export const props = Object.values(factories)
  .map((fn) => fn())
  .reduce((acc, o) => Object.assign(acc, o));
